export default {"src":"/_next/static/media/trview.ecaf208e.svg","height":68,"width":116,"blurWidth":0,"blurHeight":0};